import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { DialogData } from "@shared/confirm-dialog/confirm-dialog.component";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import { CommonService } from "@shared/services/common.service";
import storageService from "@shared/storage/storageService";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs/Rx";

@Component({
  selector: "app-ca-import-feedback-pdf",
  templateUrl: "./ca-import-feedback-pdf.component.html",
  styleUrls: ["./ca-import-feedback-pdf.component.scss"],
})
export class CaImportFeedbackPdfComponent implements OnInit {
  public fileUploadScreen: any;
  width: any = 0;
  formData: FormData = new FormData();
  file: any;
  errorMsg: any;
  successMsg: any;
  loading: boolean = false;
  selectedLanguage = "";
  currentUser: any;
  organizationData: any;
  createToaster: any;
  DEFAULT_PAGE_NO = 0;
  DEFAULT_PAGE_SIZE = 10;
  feedbackId: DialogData;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CaImportFeedbackPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,

    private router: Router,
    private broadCast: BroadCastServiceService,
    private apiService: ApiCall,
    public translate: TranslateService,
    private toastr: ToastrService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.currentUser = storageService.getItemAsJSON("currentUser");
    this.commonService.isComponent = "import-file";
    this.feedbackId = this.data?.tempdata?.id;
    this.apiService.getCurrentUser().subscribe((res) => {
      if (res) {
        this.currentUser = res.data;
      }
    });
  }

  setLanguage() {
    this.selectedLanguage = storageService.getItem("language");
    this.translate.use(this.selectedLanguage);
  }

  doFileUpload() {
    let currentUrl = this.router.url;
    this.fileUploadScreen = "fileLoading";
    this.router.navigate(["Your actualComponent"]);
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.fileUploadScreen = "fileLoading";
  }

  refresh() {
    let currentUrl = this.router.url;
    this.router.navigate([currentUrl]);
  }

  runProgressBar() {
    Observable.timer(0, 100)
      .takeWhile(() => this.isWidthWithinLimit())
      .subscribe(() => {
        this.width = this.width + 1;
        if (this.width === 100) {
          //cong
          this.fileUploadScreen = "success";
        }
      });
  }

  isWidthWithinLimit() {
    if (this.width === 100) {
      return false;
    } else {
      return true;
    }
  }

  onSuccess(): void {
    this.width = 0;
    this.dialogRef.close(false);
    this.broadCast.sendMessage("getAllFeedbacks");
  }

  cancelUpload(): void {
    this.width = 0;
    this.dialogRef.close(false);
    this.broadCast.sendMessage("getUser");
    this.broadCast.sendMessage("organization");
  }

  onFileSelect($event: any) {
    this.file = $event.target.files[0];
    this.formData.append("file", this.file);
  }

  createUsers(): void {
    try {
      this.dialogRef.disableClose = true;
      this.loading = true;
      this.apiService
        .uploadFeedbackPDF(this.feedbackId, this.formData)
        .subscribe(
          (res: any) => {
            if (res.status === "SUCCESS") {
              let message = [];
              this.translate
                .get(["BULK_USER_CREATION_SUCCESS"])
                .subscribe((translations) => {
                  message = translations["BULK_USER_CREATION_SUCCESS"];
                });
              this.successMsg = message;
              this.fileUploadScreen = "success";
              // this.broadCast.sendMessage("chief-account");
            }
          },
          (error) => {
            console.error("Error : ", error);
          },
          () => {
            this.dialogRef.disableClose = false;
            this.loading = false;
          }
        );
    } catch (error) {
      console.error("Error occurred while creating users, ", error);
    }
  }

  closePopup() {
    this.dialogRef.close();
  }
}
